import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';
import { Columns } from '@shared/interfaces/table/column-config';

export const meterFrameTypePartial: Columns<any> = {
  title: 'meterFrame.type',
  key: 'meterFrameType',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    primary: 'meterFrame.types.primary',
    station: 'meterFrame.types.station',
    serial: 'meterFrame.types.serial',
    parallel: 'meterFrame.types.parallel',
  }
}
